// extracted by mini-css-extract-plugin
module.exports = {"tariff-calculator-image":"TariffCalculatorSwitch_tariff-calculator-image_31p4y"};